/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_FeedbackInputs */



/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Manual_Qc_Type_FeedbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_feedback = /** @type {((inputs?: Manual_Qc_Type_FeedbackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_FeedbackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückmeldung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Feedback")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратная связь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("反馈")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィードバック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिक्रिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opinião")
	return /** @type {LocalizedString} */ ("Feedback")
});